

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.profilemanagement', ['squid']).factory('$MerchantPreferenceModel', function ($Model, $Api, $config, $util) {

        return $Model.extend('MerchantPreferenceModel', {

            init: function init() {

                this._super.init.apply(this);

                this.setProperties({
                    rm: $util.param('rm'), // Return Method
                    return_url: $util.param('return'),
                    auto_return: {
                        enabled: false
                    },
                    pdt: {
                        enabled: false
                    }
                });
            },

            api: new $Api({
                baseURI: $config.urls.baseUrl,
                uri: '/api/profilemanagement/:id/getMerchantPreferences'
            }),

            autoReturn: function autoReturn() {
                return this.auto_return.enabled;
            },

            pdtEnabled: function pdtEnabled() {
                return this.pdt && this.pdt.enabled;
            },

            returnUrl: function returnUrl() {
                return this.return_url || this.auto_return.url;
            },

            /**
             * 0 – redirect using GET method ( default behavior )
             * 1 – redirect using the GET method, but no payment variables are included
             * 2 – redirect using the POST method, and include all payment variables
             */
            returnMethod: function returnMethod() {
                var rm = this.rm;
                if (rm === '2') {
                    return this.pdtEnabled() ? 'GET' : 'POST';
                } else {
                    return 'GET';
                }
            },

            returnMethodSupported: function returnMethodSupported() {
                return this.returnMethod() === 'GET';
            },

            /**
             * Determines if payment details need to be sent back to the merchant.
             * @returns {boolean}
             */
            postPaymentData: function postPaymentData() {
                return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
            },

            // charset of merchant having in profile
            charSet: function charSet() {
                return this.charset;
            }
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/profilemanagement/index.js
 ** module id = 383
 ** module chunks = 1
 **/